import React, { useEffect, useState } from "react";
import { getEvents } from "../Service/Api";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
const HomeEvent = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const getData = async () => {
      const datas1 = await getEvents();
      const datas = datas1.filter((item) => item.school === "FARRUKHABAD");
      setData(datas);
    };
    getData();
  }, []);
  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const emptyArray = [
    {
      title: "Event Title",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/event3.jpg",
    },
    {
      title: "Event Title",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/event2.jpg",
    },
    {
      title: "Event Title",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/event1.jpg",
    },
  ];
  return (
    <>
      <div className="row">
        <div className="eventbg">
          <Slider {...settings}>
            {data.length > 0
              ? data.map((item, index) => (
                  <div className="item" key={index}>
                    <div className="homeeventbox">
                      <div className="homeeventboximg">
                        <LazyLoad>
                          {" "}
                          <img
                            src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.images}`}
                            className="img-fluid"
                            alt="Gayatri International School"
                          />{" "}
                        </LazyLoad>
                      </div>
                      <div className="homeeventboxdesc">
                        <div className="date">{item.date}</div>
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                        <div className="d-flex justify-space-between">
                          <p> {item.venue} </p>
                          <p>{item.time}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              : emptyArray.map((item, index) => (
                  <div className="item" key={index}>
                    <div className="homeeventbox">
                      <div className="homeeventboximg">
                        <img
                          src={item.attachments}
                          className="img-fluid"
                          alt="Gayatri International School"
                        />
                      </div>
                      <div className="homeeventboxdesc">
                        <div className="date">DD MM</div>
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                        <div className="d-flex justify-space-between">
                          <p> School Campus </p>
                          <p>08:00 AM</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default HomeEvent;
